import {Component, Input, OnDestroy, Inject, ViewEncapsulation} from '@angular/core';
import {Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError} from '@angular/router';
import {DOCUMENT} from '@angular/common';

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',

    encapsulation: ViewEncapsulation.None,
    styleUrls:['./spinner.component.scss']
})
export class SpinnerComponent implements OnDestroy {

    @Input() public backgroundColor = 'rgba(51, 86, 172, 0.69)';
    private tokenTimer: any;
    public isSpinnerVisible: boolean = true;

    constructor(private router: Router, @Inject(DOCUMENT) private document: Document) {
        // console.log('SpinnerComponent');
        const self = this;
        this.router.events.subscribe(event => {

            if (event instanceof NavigationStart) {
                // console.log('nav start');
                self.isSpinnerVisible = true;
            } else if ( event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
                if (self.isSpinnerVisible) {
                    self.tokenTimer = setTimeout(() => {
                        // console.log('timeout resize');

                        window.dispatchEvent(new Event('resize'));

                        try {
                            clearTimeout(self.tokenTimer);
                        } catch (e) {
                        }


                    }, (1000));
                    self.isSpinnerVisible = false;
                }
                // console.log('Spinner Off');

            }
        }, () => {
            // console.log('Spinner error');
            self.isSpinnerVisible = false;
        });
    }

    ngOnDestroy(): void {
        // console.log('Spinner OnDestroy');
        this.isSpinnerVisible = false;
    }
}
